import React, { Component } from 'react';
import { isEmpty, size, sumBy } from "lodash";
import { 
    IconButton,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TableFooter,
    TablePagination,
    Button,
    TableContainer,
    Box,
} from '@mui/material';
import Pagination from '../../../container/MUI/Pagination';
import Dialog from '../../common/Dialog';
import { orderByDateAsc, orderByDateDsc } from '../../../store/actions/format';
import Currency from '../../common/Currency';
import SpendingDetails from '../../Spendings/SpendingDetails';
import { CloudDownloadRounded } from '@mui/icons-material';

const TRANSLATE = {
    CREDIT: "AVANCE",
    DEBIT: "RETOUR AVANCE",
    PAYMENT: "PAYMENT",
}
// let totalDebit = 0 
// let totalCredit = 0 

class CreditsListUser extends Component {
    state = { 
        page: 0,
        rowsPerPage: 15,
        openDetails: false,
        credit: {},
        pay: {},

    }
    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ page: 0, rowsPerPage: parseInt(event.target.value) });
    };

    componentWillMount() {
        window.scrollTo(0, 0);
    }
    createHistory = () => {
        const { USER_CREDITS, USER_PAYMENTS } = this.props
        let list = []
        USER_CREDITS.forEach( cred => {
            list.push({
                item : cred,
                amount : cred.credit_amount,
                id : cred.credit_id,
                date : cred.credit_creation_date,
                available: cred.credit_total_available,
                op: cred.credit_op,
                bank: cred.credit_bank,
                // background : ,
            })
        })
        USER_PAYMENTS.forEach( payment => {
            if (payment.payments_spendings) {
                payment.payments_spendings.forEach(pay => {
                    if ( !pay.payment_is_avance){
                        list.push({
                            item : payment,
                            amount : pay.payment_amount,
                            id : pay.payment_details_id,
                            // id : pay.payment_id,
                            spending : pay.payment_spending_id,    
                            date : pay.payment_details_date,    
                            op: "PAYMENT"            
                        })
                    }
                })
            }
        })

        list = orderByDateAsc(list, "date")
        console.log('====================================');
        console.log({list, debit: list.filter(item => item.op !== "CREDIT"), credit: list.filter(item => item.op === "CREDIT") });
        console.log('====================================');
        return list
    }
    getHistoryList = () => {
        const { rowsPerPage, page } = this.state;
        const {admin, BANKS} = this.props;

        let list = this.createHistory()
        console.log('====================================');
        console.log({list, debit: list.filter(item => item.op === "CREDIT")});
        console.log('====================================');
        // totalDebit = sumBy(list.filter(item => item.op !== "CREDIT"), "amount") 
        // totalCredit = sumBy(list.filter(item => item.op === "CREDIT"), "amount") 
        if (!isEmpty(list) ){

            return list.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(item => {
                // let background = item.credit_op === "DEBIT" ? "#e48a88b3" : "light-blue"
  
                return (
                    <TableRow hover key={item.id} className="clickable" 
                        // style={{ background }}
                        // onClick={item.op === "PAYMENT" && (() => this.setState({ openDetails: true, spending: SPENDINGS.USER[item.spending] }))}    
                        title="Voir le Détail"
                    >
                        {/* <th scope="row">{item.user}</th> */}
                        <TableCell>{new Date(item.date).toLocaleDateString('fr-FR')}</TableCell>
                        <TableCell>{item?.item?.credit_ref}</TableCell>
                        <TableCell>{TRANSLATE[item.op]}</TableCell>
                        <TableCell>{(item.op === "PAYMENT" || item.op === "DEBIT") && `-${item.amount}`}</TableCell>
                        <TableCell>{item.op === "CREDIT" && item.amount}</TableCell>
                        <TableCell>{item.op === "CREDIT" && item.available}</TableCell>
                        {admin && <TableCell>{item.bank && BANKS[item.bank].bank_name }</TableCell>}
                    </TableRow>
                )
            })
        }
    }
    // e632cccf-b3e2-4447-9c83-e62ab104c1a7
    handleClose = () => {
		this.setState({ 
            openDetails: false,
            credit: {},
            spending: {},
        });
    };    
        
    render() {
        const { USER_CREDITS, USER_PAYMENTS, user, CATEGORIES, SUPPLIERS, admin } = this.props;
        const { rowsPerPage, page, openDetails, credit, spending } = this.state;
        console.log('========= STATE CREDIT LIST ========');
        console.log(this.state);
        console.log('====================================');
        return (
            // <Dialog
            //     open={true}
            //     close={this.props.handleCloseAll}
            //     title="Historique"
            //     maxWidth="md"
            //     fullWidth
            // >
            <Box>

                {openDetails && !isEmpty(spending) && 
                    <SpendingDetails 
                        supplier={SUPPLIERS && SUPPLIERS[spending.spending_supplier]} 
                        category={CATEGORIES.CHILD && CATEGORIES.CHILD[spending.spending_category]} 
                        spending={spending} 
                        view={"USER"}
                        handleClose={()=> this.setState({openDetails: false, spending: {}})}
                    />
                }
                {/* {openDetails && !isEmpty(credit) && 
                    <CreditDetailsUser handleClose={this.handleClose} {...this.props} credit={credit} />
                } */}
                {admin &&
                    <Box style={{ textAlign: "right"}}>
                        <IconButton color="primary" onClick={() => this.props.handleDownload("/extract/user/history", `Historique_${user.lastname}.csv`, user.user_id)} title="Télécharger" disabled={this.props.downloading}>
                            <CloudDownloadRounded />
                        </IconButton>
                    </Box>
                }
                                
                {/* {fetchedUserCredits && fetchedUserDebits && */}
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Créé le</TableCell>
                                    <TableCell>Ref</TableCell>
                                    <TableCell>Type</TableCell>
                                    <TableCell>Debit</TableCell>
                                    <TableCell>Credit</TableCell>
                                    <TableCell>Restant</TableCell>
                                    {admin && <TableCell>Banque</TableCell>}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            <TableRow 
                                title="Solde"
                            >
                                <TableCell colSpan={2}><Typography variant="subtitle" color="primary">Solde au {new Date().toLocaleString('fr-FR')}</Typography></TableCell>
                                  <TableCell></TableCell>
                                <TableCell><Currency value={this.props.totalDebit} /></TableCell>
                                <TableCell><Currency value={this.props.totalCredit} /></TableCell>
                                <TableCell><Typography color="primary"><Currency value={user.account}/></Typography></TableCell>
                                {admin && <TableCell></TableCell>}
                            </TableRow>
                            {/* <TableRow 
                                title="Total"
                            >
                                <TableCell colSpan={2}></TableCell>
                                <TableCell><Typography color="primary"><Currency value={user.account}/></Typography></TableCell>
                                <TableCell></TableCell>
                                {admin && <TableCell></TableCell>}
                            </TableRow> */}
                                {this.getHistoryList()}
                            </TableBody>
                            {(USER_CREDITS.length + USER_PAYMENTS.length) > rowsPerPage &&
                                <TableFooter>
                                    <TableRow>
                                        <TablePagination
                                            rowsPerPageOptions={[15, 30]}
                                            labelRowsPerPage="Lignes par Page"
                                            colSpan={6}
                                            count={(USER_CREDITS.length + USER_PAYMENTS.length)}
                                            rowsPerPage={rowsPerPage}
                                            page={page}
                                            SelectProps={{
                                                native: true,
                                            }}
                                            onPageChange={this.handleChangePage}
                                            onRowsPerPageChange={this.handleChangeRowsPerPage}
                                            ActionsComponent={Pagination}
                                        
                                        />
                                    </TableRow>
                                </TableFooter>
                            }
                        </Table> 
                    </TableContainer>
                {/* }                 */}
            </Box>
            // </Dialog>
        );
    }
}

export default CreditsListUser;